import { render } from "./BatchParticipantsDetails.vue?vue&type=template&id=cb9545aa"
import script from "./BatchParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./BatchParticipantsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__